//  names of clusters
const MARKETING = "marketing";
const CRM = "crm";
const NON_PROFIT = "ngo";
const OPERATIONS = "operations";
const DESIGN_AND_CREATIVE = "design_and_creative";
const SOFTWARE = "tech";
const HR = "hr";
const IT = "information_technology";
const EDUCATION = "education";
const CONSTRUCTION = "construction";

// SubCluster
const WORK_DOCS_SUB_CLUSTER = "workdocs";

//  names of use cases
const PROJECT_MANAGEMENT_USE_CASE = "project_management";

const DEFAULT = "default"; // no cluster
const GENERIC_CLUSTER = "generic";

//  events where you get clusters
const HP_TAGS_SELECTION = "hp_tags_selection";

module.exports = {
  MARKETING,
  CRM,
  DEFAULT,
  GENERIC_CLUSTER,
  HP_TAGS_SELECTION,
  NON_PROFIT,
  OPERATIONS,
  DESIGN_AND_CREATIVE,
  SOFTWARE,
  HR,
  IT,
  PROJECT_MANAGEMENT_USE_CASE,
  EDUCATION,
  CONSTRUCTION,
  WORK_DOCS_SUB_CLUSTER
};
